export const AMENDATORY_ENDORSEMENTS = 'AMENDATORY_ENDORSEMENTS';

/**
 * The ZSP family names its amendatory coverage category AMENDATORY_ENDORSEMENTS;
 * every other rater (P_ONE, P100_PRO, P250X, PRIME_TECH, PRIME_ONE_US,
 * PRIME_ONE_PLUS_US, PRIME_ONE_TECH, PRIME_ONE_AU) names it
 * AMENDATORY_ENDORSEMENTS_CATEGORY. Match on both rather than on either alone.
 */
export const AMENDATORY_ENDORSEMENTS_CATEGORY = 'AMENDATORY_ENDORSEMENTS_CATEGORY';

export function isAmendatoryCategory(categoryKey: string | undefined): boolean {
  return (
    categoryKey === AMENDATORY_ENDORSEMENTS ||
    categoryKey === AMENDATORY_ENDORSEMENTS_CATEGORY
  );
}

/*These represent the actionable amendatory coverage for a UW. All coverages are not defined here */
export enum AmendatoryCoverages {
  ADDITIONAL_INSURED = 'ADDITIONAL_INSURED',
  AMEND_COOPERATION = 'AMEND_COOPERATION',
  AMEND_NOTICE_PROVISION = 'AMEND_NOTICE_PROVISION',
  DEFENSE_COUNSEL = 'DEFENSE_COUNSEL',
  SPECIFIED_EVENT_EXCLUSION = 'SPECIFIED_EVENT_EXCLUSION',
}

/* Used to avoid string checking in UW rater options section */
export enum UW_RATER_OPTION_KEYS {
  REVENUE_FACTORS = 'revenueFactors',
  ASSOCIATION_CREDIT = 'associationCredit',
  EXPERIENCE_MODIFICATION = 'experienceModification',
  IRPM = 'irpm',
  ADMIN_FEE = 'adminFee',
  TRIA = 'tria',
  COMMISSION_RATE = 'commissionRate',
  PREMIUM_ROUNDING_OFFSET = 'premiumRoundingOffset',
}

export const STRIP_CURRENCY_CHARS_REGEX = /[^0-9.-]/g;
